// ===========================================
// HOOK: useRegistrarPagoForm
// ===========================================
// Hook TanStack Form para registrar pago de vencimiento

import { useForm } from '@tanstack/react-form'
import { format } from 'date-fns'
import { registrarPagoSchema, type RegistrarPagoFormValues } from './registrarPagoSchema'

interface UseRegistrarPagoFormOptions {
  onSubmit?: (value: RegistrarPagoFormValues) => Promise<void>
  defaultValues?: Partial<RegistrarPagoFormValues>
}

export function useRegistrarPagoForm(options: UseRegistrarPagoFormOptions = {}) {
  const form = useForm({
    defaultValues: {
      fecha_pago: format(new Date(), 'yyyy-MM-dd'),
      monto_pagado: null,
      forma_pago: null,
      referencia_pago: null,
      observaciones: null,
      ...options.defaultValues,
    } as RegistrarPagoFormValues,
    validators: {
      onSubmit: registrarPagoSchema,
    },
    onSubmit: async ({ value }) => {
      if (options.onSubmit) {
        await options.onSubmit(value)
      }
    },
  })

  return { form }
}

export type UseRegistrarPagoFormReturn = ReturnType<typeof useRegistrarPagoForm>
export type RegistrarPagoForm = UseRegistrarPagoFormReturn['form']
